import CategoryLink from '@jetshop/ui/CategoryLink';
import Image from '@jetshop/ui/Image';
import { styled } from 'linaria/react';
import React from 'react';
import { BackArrow } from '../CategoryPage/CategoryHeader';
import { BreadcrumbsWrapper } from '../Layout/BreadcrumbsWrapper';
import { PagePadding } from '../Layout/MaxWidth';
import { theme } from '../Theming/Theming';
import { BlogArticleMaxWidth } from './BlogArticle';

const BlogHeaderWrapper = styled('div')`
  position: relative;
  .parent {
    padding: 5px 10px;
    margin-bottom: 0.8rem;
    background: ${theme.colors.primary};
    color: ${theme.colors.white};
    > a {
      color: ${theme.colors.white};
    }
    display: inline-block;
    position: relative;
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 0;
      height: 0;
      border: 0.5rem solid transparent;
      border-bottom: 0;
      border-left: 0;
      margin-bottom: -0.5rem;
      border-top-color: ${theme.colors.primary};
    }
  }
  .blog-header-text {
    padding: 5px 0;
    .blog-header-title-wrapper {
      display: flex;
    }
    .blog-header-title {
      line-height: 1;
    }
  }
  .blog-header-image {
    ${theme.below.sm} {
      padding-bottom: 50% !important;
    }
    &:after {
      top: 0px;
      left: 0px;
      position: absolute;
      width: 100%;
      height: 100%;
      content: ' ';
      background: linear-gradient(
        rgba(0, 0, 0, 0.1) 0%,
        rgba(0, 0, 0, 0.3) 60%,
        rgba(0, 0, 0, 0.8) 100%
      );
    }
  }
  &[data-hasimage='true'] {
    position: relative;
    .breadcrumbs-wrapper {
      padding: 0.5rem 0;
      li,
      li > a {
        color: ${theme.colors.greys[4]};
      }
    }
    .back-arrow {
      position: absolute;
      top: 5px;
      svg {
        color: ${theme.colors.white};
      }
    }
    .blog-header-text {
      position: absolute;
      z-index: 1;
      bottom: 0;
      .blog-header-title {
        color: ${theme.colors.white};
      }
    }
  }
`;

const BlogHeader = ({ category, parentCategory, breadcrumbProps }) => {
  const hasImage = category.images && category.images.length > 0;
  return (
    <>
      <BlogHeaderWrapper
        className="blog-header"
        data-hasimage={hasImage ? true : false}
      >
        {hasImage && (
          <Image
            className="blog-header-image"
            src={category.images}
            alt={category.name}
            sizes={[1, 1, 1, 1]}
            aspect={'3:1'}
            crop={true}
            cover
            critical={true}
          />
        )}
        <PagePadding>
          <BlogArticleMaxWidth>
            <BackArrow parents={breadcrumbProps.parents} />
            <header className="blog-header-text">
              {parentCategory && (
                <h5 className="parent">
                  <CategoryLink category={parentCategory}>
                    {parentCategory.name}
                  </CategoryLink>
                </h5>
              )}
              <h1 className="blog-header-title">{category.name}</h1>
              <BreadcrumbsWrapper {...breadcrumbProps} />
            </header>
          </BlogArticleMaxWidth>
        </PagePadding>
      </BlogHeaderWrapper>
    </>
  );
};

export default BlogHeader;
